export default __webpack_public_path__ + "static/media/61.33f72843.png";